module.exports = __webpack_public_path__ + "static/media/adsk-projects working.d665874a.csv";